<div #postImageContainer class="post-background">
  <a [routerLink]="['/post/']" queryParamsHandling="merge" class="post-img-container"
     [ngStyle]="{'backgroundImage': hasDimension(post) ? 'url(' + post.imageUrl + ')' : 'none'}"
     [queryParams]="{influencerId: post.blog_id, urlHash: post.urlHash, fullUrl: post.url, relativePath: post.relativepath, hideBackButton: true, activeAccount: activeAccount}" 
     target="_blank">
    <img #postImage *ngIf="hasDimension(post)" class="post-img" style="display: none"
         [ngClass]="{'story-image': post.isStory}" (load)="onLoadedImage()" (error)="onLoadImageError()"
         [src]="post.imageUrl" alt="No image"
         onerror="this.onerror=null;this.src='assets/images/No_Image.png'" />
    <div #postImage class="post-image-missing-dimension" *ngIf="!hasDimension(post)">
      <blurry-backdrop-image [image]="post.imageUrl"
                             (afterLoaded)="onLoadedImage()" (error)="onLoadImageError()">
      </blurry-backdrop-image>
    </div>

  </a>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/post-image/post-image.component.html